














































import {
    IOmnichannelFindMissedStoreParamsRequest,
    IOmnichannelStrategyTableParams,
} from '@/pages/omnichannel-strategy/types/data';
import OmnichannelStrategyApi from '@/pages/omnichannel-strategy/api/OmnichannelStrategyApi';
import {Component, Prop} from 'vue-property-decorator';
import Vue from "vue";

@Component
export default class OmnichannelConfirmModal extends Vue {
    @Prop() readonly request!: IOmnichannelFindMissedStoreParamsRequest

    private api: OmnichannelStrategyApi = new OmnichannelStrategyApi({parent: this});

    private loading: boolean = true;

    private missedBaseStoreParams: IOmnichannelStrategyTableParams[] = [];
    private missedDependStoreParams: IOmnichannelStrategyTableParams[] = [];

    mounted() {
        this.findMissedStoreParams();
    }

    findMissedStoreParams(): void {
        this.loading = true;

        setTimeout(() => {
            this.api.findMissedStoreParams(this.request)
                .then((resp) => {
                    this.missedBaseStoreParams = resp.data.baseStoreParams;
                    this.missedDependStoreParams = resp.data.dependStoreParams;
                }).catch((err) => {
                    this.$log.error('Error occurred during search missed store params', err);
                }).finally(() => {
                    this.loading = false;

                    this.$emit('store-params-loaded');
                });
        }, 1500);
    }

    private get isBaseStoreParamsMissed(): boolean {
        return !!this.missedBaseStoreParams.length;
    }

    private get isDependStoreParamsMissed(): boolean {
        return !!this.missedDependStoreParams.length;
    }
}
